import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useState } from 'react'
import useEditor from 'hooks/useEditor'
import { useDispatch, useSelector } from 'react-redux'
import { setBillsData, setEdittedRow, setInvoiceStatues } from 'redux/features/projectDetail/projectDetailSlice'
import { useEffect } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { useParams } from 'react-router-dom'
import { ConfirmDialog } from 'primereact/confirmdialog';
import { currencyFormatter } from 'utils/CurrencyFormatter';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { userInfo } from 'utils/Auth'
import { Tooltip } from 'primereact/tooltip'
import Button from 'components/formElements/Button'
import Icons from 'assets/icons'
import moment from 'moment';
import {Calendar} from 'primereact/calendar';

const InvoiceReport = () => {

    const { projectId } = useParams()
    const [getBillsData] = useRequest()
    const [getInvoicesStatus] = useRequest()
    const [request] = useRequest()
    const [selectedRow, setSelectedRow] = useState(null)
    const [customerName, setCustomerName] = useState('');
    const { projectDetail } = useSelector((state) => state)
    const { billsData } = projectDetail
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [billNo, setBillNo] = useState();
    const [description, setDescription] = useState();
    const [billDate, setBillDate] = useState();
    const [key, setKey] = useState(false);


    const { showToast } = useToast()
    const dispatch = useDispatch()
    const { textEditor, currencyEditor } = useEditor()

    useEffect(() => {
        getBillsData('/Invoices/GetAllInvoices', {
            method: 'GET', params: { invoiceStatus: "kesilebilir" }
        }).then((res) => {
            if (res?.data?.ok) {
                setLoading(false);
                const data = res?.data?.result?.map(p => ({...p,project:{...p?.project,projectRoles:p.project.projectRoles.filter(r => (!r.endDate || (r.endDate && moment(new Date(), 'YYYY-MM-DD').diff(moment(r.endDate).format('YYYY-MM-DD'), 'days') < 1)))}}))
                dispatch(setBillsData(data))
                setCustomerName(data.filter((a, i) => data.findIndex((s) => a.project.customerName === s.project.customerName) === i))
            }
        })
        getInvoicesStatus('/InvoiceStatus/GetAllInvoiceStatuses', { method: 'GET' }).then(res => {
            if (res?.data?.ok) {
                dispatch(setInvoiceStatues(res.data.result.map(d => {
                    return { value: d.id, label: d.name }
                })))
            }
        })
    }, [projectId])

    const renderHeader2 = () => {
        return (
            <div className="flex justify-content-between ">
                <span className="p-input-icon-left ">
                    <i className="pi pi-search" />
                    <InputText
                        style={{ maxWidth: "20rem" }}
                        placeholder="Müşteri / Şirket Adı" value={filters} options={customerName} onChange={onGlobalFilterChange}/>
                </span>  </div>)
    }
    const [filters, setFilters] = useState('');
    const onRowEditComplete1 = () => {
        let _products2 = [...billsData];

        if (!billNo || !billDate) {
            showToast('Fatura Numarasını ve Tarihini Giriniz.', 'error')

        } else {
            request('/Invoices/UpdateInvoicesComplated', {
                method: 'PUT',
                params: { invoceId: selectedRow?.id, invoiceNo: billNo, date:billDate,description:description }

            }).then((res) => {
                if (res?.data.ok) {
                    dispatch(setBillsData(_products2.filter(b => b.id != selectedRow?.id)))
                    showToast('Fatura Bilgisi Güncellendi.', 'success')
                    setSelectedRow(null)
                    setBillNo(null)
                    setBillDate(null)
                    setDescription(null)
                    setVisible(false)

                }
                dispatch(setEdittedRow({}))
            })
        }


    }
    const getProjectRoles = (roles,role ) => {
        const filtered = roles?.filter(r => r.projectRole.normalizedName == role)?.map(r => (`${r.user.firstName} ${r.user.lastName}`))?.join(', ')
        return filtered
    }
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setFilters(value);
    }
    const openDialog = (rowData, key) => {
        setVisible(true)
        setSelectedRow(rowData)
        setKey(key)
        setDescription(rowData.description)
    }
    const header2 = renderHeader2();
    const footerContent = () => (
        <div style={{ display: "flex", justifyContent: "end" }}>
            <Button title="Onayla" handleClick={() => onRowEditComplete1(key)} className="btn-success" />
            <Button title="Vazgeç" handleClick={() => setVisible(false)} className="btn-danger" />
            {billNo ? <Tooltip target=".logo" mouseTrack mouseTrackLeft={10} /> : ""}
        </div>
    );
    const filteredData = filters ? billsData?.filter(f => f?.project?.customerName?.toLocaleLowerCase('tr')?.includes(filters?.toLocaleLowerCase('tr')) || f?.project?.name?.toLocaleLowerCase('tr')?.includes(filters?.toLocaleLowerCase('tr'))) : billsData
    return userInfo['Invoice.read'].includes('True') &&
        <AnimatedSpan className='page-container d-flex flex-column'>
            <ConfirmDialog />
            <div className='row-margin-x'>
                <div className='col-md-12'>
                    <DataTable
                        responsiveLayout="scroll"
                        loading={loading}
                        header={header2}
                        className='p-1'
                        editMode='row'
                        dataKey='id'
                        stripedRows
                        onRowEditComplete={onRowEditComplete1}
                        value={filteredData}
                        onRowEditInit={e => dispatch(setEdittedRow(e.data))}
                    >
                        <Column
                            className='text-semi-bold text-sm'
                            field='project.customerName'
                            style={{ width: "auto" }}
                            header='Müşteri / Şirket Adı '
                            sortable='true'
                            body={(rowData) => {
                                return <div >
                                {rowData?.project?.customerName && `${rowData?.project?.customerName}`}
                            </div>
                            }}
                        />
                        <Column
                            className='text-semi-bold text-sm'
                            field='project.name'
                            style={{ width: "auto" }}
                            header='Proje Adı'
                            editor={(options) =>
                                textEditor(options)
                            } />
                        <Column
                            className='text-semi-bold text-sm'
                            field='name'
                            style={{ width: "auto" }}
                            header='Fatura Adımı'
                            editor={(options) =>
                                textEditor(options)
                            } />
                             <Column
                                className='text-semi-bold text-sm'
                                headerClassName='text-bold bg-primary text-default'
                                field='estimatedDate'
                                header='Kesilecek Ay'
                                style={{ width: 'auto' }}
                                sortable='true'
                                body={(rowData) => {
                                    const expectedDate = rowData.estimatedDate && moment(rowData.estimatedDate)
                                    const diff = rowData.estimatedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'month')
                                    return (
                                    <span className={diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) ? 'text-danger' : ''}>
                                        {' '}
                                        <span>{expectedDate && expectedDate.format('ll')}</span> <span>{diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) && 'Süresi Geçti'}</span>
                                    </span>
                                    )
                                }}
                                />
                        <Column
                            className='text-semi-bold text-sm'
                            field='sourceType'
                            style={{ width: "auto" }}
                            header='AM Adı'
                            body={(rowData) => {
                                return (
                                    <span>
                                        {getProjectRoles(rowData?.project?.projectRoles,'ACCOUNTMANAGER')}
                                    </span>
                                )
                            }}
                        />
                        <Column
                            className='text-semi-bold text-sm'
                            field='sourceType'
                            style={{ width: "auto" }}
                            header='PM Adı'
                            body={(rowData) => {
                                return (
                                    <span>
                                        {getProjectRoles(rowData?.project?.projectRoles,'PROJECTMANAGER')}
                                    </span>
                                )
                            }}
                        />
                        <Column
                            className='text-semi-bold text-sm'
                            style={{ width: "auto" }}
                            headerClassName='text-bold bg-primary text-default'
                            field='amount'
                            body={(rowData) => {
                                return (
                                    <span>
                                        {currencyFormatter(rowData.amount)} {rowData.currency}
                                    </span>
                                )
                            }}
                            header='Tutar'
                            editor={(options) => currencyEditor(options)} />
                        <Column
                            field='action'
                            style={{ width: '10rem' }}
                            headerClassName='text-bold bg-primary text-default'
                            className='text-semi-bold '
                            body={(rowData, key) =>
                                <Button handleClick={() => openDialog(rowData, key)} style={{ borderRadius: "10rem", fontSize: "0.8rem" }} icon={<Icons.invoice />} title='Faturayı Kes' className='btn-bill' />
                            } />
                    </DataTable>
                </div>
            </div>

            <Dialog header="Faturayı Kesiniz" visible={visible} style={{ width: '30rem' }} onHide={() => {setVisible(false);setBillNo(null);setBillDate(null)}} footer={footerContent()}>
                <div className='form-control'>
                    <label htmlFor="" className="form-control-label">
                        Fatura Numarası
					</label>
                    <input
                        placeholder='Fatura Numarasını Giriniz'
                        className='default-input'
                        type='text'
                        name='invoiceNo'
                        onChange={(e) => setBillNo(e.target.value)}
                    />                
                </div>
                {/* <div className='form-control mt-3'>
                    <label htmlFor="" className="form-control-label">
							Açıklama
					</label>
                    <input
                        placeholder='Açıklama Giriniz'
                        className='default-input'
                        type='text'
                        name='description'
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />                
                </div> */}
                <div className="form-control mt-3">
                    <label htmlFor="" className="form-control-label">
                        Fatura Tarihi
					</label>
                <Calendar
                    className='w-100'
                    dateFormat='dd/mm/yy'
                    placeholder='Fatura Tarihi'
                    name='startDate'
                    onChange={(e) => {
                        setBillDate(moment(e.target.value).add(3, 'hours').toISOString())
                    }}
                />
                </div>
                <div className="form-control mt-3">
                {
                    description && <div style={{wordBreak:'break-word'}} className="form-control-label">
                    Açıklama: {description}
                </div>
                }
                </div>
                <Tooltip target=".custom-target-icon" />
            </Dialog>
        </AnimatedSpan>
}

export default InvoiceReport
